export const isEmpty = (obj: Object): boolean => {
  return (
    Object.keys(obj).length === 0 || Object.values(obj).every((x) => x === "")
  );
};
